module.exports = __webpack_public_path__ + "img/MoonSword 6b.f24c4a6d.png";